/* eslint-disable no-unused-vars */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import {
  Button,
  DatePicker,
  Input,
  InputNumber,
  Modal,
  Select,
  Spin,
  message,
} from 'antd'
import { ErrorContext, JcTmpErrorContext, SpinContext } from 'context'
import { getEventTypes } from 'core'
import { Label } from 'core/screen-util'
import React, { useContext, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import R from 'ramda'
import moment from 'moment'
import MultiCauseCode from 'card-data/MultiCauseCode'
import { wind2EventUpdateTurbine } from 'api/pgads'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'
import { getTimeZone, timeZoneOption } from './wind2utils'
import { getPermitActions } from '../core/selectors'
import { WIND_ADMIN_POWER_DATA_20 } from '../core/EventActions'
import { hasAccesPermits } from 'core/utils'
import styled from 'styled-components'

const CustomSelect = styled(Select)`
  .ant-select-selection--multiple {
    max-height: 120px; /* Adjust height as needed */
    overflow-y: auto; /* Enable scrolling when content overflows */
  }
`

const Wind2TurbineEventDialog = ({
  targetInfo,
  visible,
  data = {},
  onHide = _ => _,
  onRetrieve,
  isNew = false,
  causeCodeList,
  contribConditionList = [],
  turbineList = [],
  selectedPlantDetails = {},
  eventTypes = [],
  actionPermits,
}) => {
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const { timeZone = 'EST', daylightSaving = 'Y' } = selectedPlantDetails
  const efffEventType = useMemo(
    _ => eventTypes.filter(f => f.eventFor === 'T'),
    [eventTypes]
  )

  const hasWindPowerDataWritePermission = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [WIND_ADMIN_POWER_DATA_20],
        matchAny: true,
      }),
    [actionPermits]
  )

  const [insertData, setInsertData] = useState({
    ...data,
    contributingCondition: data.contributingCondition || '0',
  })
  const { setTmpError } = useContext(JcTmpErrorContext)

  const onSave = _ => {
    const { plantId, eventstart, eventstartTimeZone, turbineId } = insertData
    if (!turbineId) {
      message.info('Please, insert Turbine ID')
      return
    }

    if (!plantId) {
      message.info('Please, Select Plant.')
      return
    }
    if (!eventstart) {
      message.info('Please. Select Event Start Time.')
      return
    }
    if (!eventstartTimeZone) {
      message.info('Please ,Select Event Start Time Zone.')
      return
    }

    setSpinning(true)
    const turbineIds = Array.isArray(turbineId) ? turbineId : [turbineId]
    const records = turbineIds.map(id => ({
      ...insertData,
      turbineId: id,
    }))

    wind2EventUpdateTurbine(targetInfo)(records).fork(setError, errorList => {
      setSpinning(false)
      setTmpError(errorList)
      if (!isErrorContains(errorList)) {
        message.info('Data saved.')
        onHide()
        onRetrieve()
      }
    })
  }

  const [causeCodeDialog, setCauseCodedialog] = useState({
    causeCodeDialog: false,
  })

  const onCauseCodeDialogClose = (causeCodeKeyValues, causeCodeValues) => {
    setInsertData({
      ...insertData,
      causecode: causeCodeValues[0] && causeCodeValues[0].causeCode,
    })
    setCauseCodedialog({
      causeCodeDialog: false,
      causeCodeKeyValues,
      causeCodeValues,
      causecode: causeCodeValues
        ? causeCodeValues.length > 0
          ? causeCodeValues[0].causeCode
          : ''
        : insertData.causecode,
    })
  }

  const onCauseCodeTreeCancel = causeCodeKeyValues => {
    setCauseCodedialog({
      causeCodeKeyValues,
      causeCodeDialog: false,
    })
  }
  const openCauseCodeDialog = _ => {
    setCauseCodedialog({
      causecode: insertData.causecode,
      causeCodeDialog: true,
    })
  }
  const saveDateformat = 'MM/DD/YYYY HH:mm'

  const turbineIdSort = useMemo(
    _ => {
      return R.compose(
        R.sort((a, b) => a.localeCompare(b)),
        R.map(d => d.turbineId)
      )(turbineList)
    },
    [turbineList]
  )

  return (
    <Modal
      visible={visible}
      centered
      height={400}
      width={1100}
      title={<div> Turbine Event Dialog </div>}
      footer={
        <div>
          <div>
            {hasWindPowerDataWritePermission && (
              <Button type="primary" onClick={onSave}>
                Save{' '}
              </Button>
            )}
            <Button onClick={onHide}>Cancel</Button>
          </div>
        </div>
      }
      onCancel={onHide}
    >
      <Spin spinning={spinning}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '250px 200px 150px 200px 150px',
            gap: 5,
          }}
        >
          {/* <Label>Time Zone :</Label>
          <Select value={insertData.timeZone}>
            <Select.Option value="EST">EST</Select.Option>
            <Select.Option value="EDT">EDT</Select.Option>
          </Select> */}

          <Label>Turbine Id :</Label>
          {isNew && (
            <CustomSelect
              showSearch
              mode="multiple"
              css={{ gridColumnEnd: 'span 4', width: '100%' }}
              value={insertData.turbineId}
              onChange={turbineId => {
                if (turbineId.includes('ALL')) {
                  setInsertData({
                    ...insertData,
                    turbineId: turbineIdSort.map(d => d),
                  })
                } else {
                  setInsertData({ ...insertData, turbineId })
                }
              }}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              <Select.Option key="ALL" value="ALL">
                ALL
              </Select.Option>
              {turbineIdSort.map(d => (
                <Select.Option key={d} value={d}>
                  {d}
                </Select.Option>
              ))}
            </CustomSelect>
          )}
          {!isNew && (
            <Input
              style={{}}
              value={insertData.turbineId}
              onChange={e =>
                setInsertData({ ...insertData, turbineId: e.target.value })
              }
              disabled={!isNew}
            />
          )}
          {!isNew && <div style={{ gridColumnEnd: 'span 3' }} />}
          {/* <Label>Event ID :</Label>
          <Input disabled value={insertData.eventId} />
          <div style={{ gridColumnEnd: 'span 1' }} /> */}
          <Label>Event Start :</Label>
          <DatePicker
            style={{}}
            value={
              insertData.eventstart &&
              moment(insertData.eventstart, saveDateformat)
            }
            showTime={{
              format: 'h:mm',
              defaultValue: moment('00:00', 'HH:mm'),
            }}
            format="MM/DD/YYYY HH:mm"
            placeholder="Select DateTime"
            onChange={date => {
              const zone = getTimeZone({
                pzone: timeZone,
                daylightSavings: daylightSaving,
                date,
              })
              setInsertData({
                ...insertData,
                eventstart: date.format(saveDateformat),
                eventstartTimeZone: zone,
              })
            }}
            onOk={date => {
              const zone = getTimeZone({
                pzone: timeZone,
                daylightSavings: daylightSaving,
                date,
              })
              setInsertData({
                ...insertData,
                eventstart: date.format(saveDateformat),
                eventstartTimeZone: zone,
              })
            }}
          />
          <Label>Start Time Zone :</Label>
          <Select
            value={insertData.eventstartTimeZone}
            onChange={eventstartTimeZone =>
              setInsertData({ ...insertData, eventstartTimeZone })
            }
          >
            {timeZoneOption({
              pzone: timeZone,
              daylightSavings: daylightSaving,
            }).map(t => (
              <Select.Option key={t.key} value={t.value}>
                {t.text}
              </Select.Option>
            ))}
          </Select>
          <div />
          <Label>Event End :</Label>
          <DatePicker
            style={{ minWidth: '100%' }}
            value={
              insertData.eventend && moment(insertData.eventend, saveDateformat)
            }
            showTime={{
              format: 'h:mm',
              defaultValue: moment('00:00', 'HH:mm'),
            }}
            format="MM/DD/YYYY HH:mm"
            placeholder="Select DateTime"
            onChange={date => {
              const zone = getTimeZone({
                pzone: timeZone,
                daylightSavings: daylightSaving,
                date,
              })
              setInsertData({
                ...insertData,
                eventend: date.format(saveDateformat),
                eventendTimeZone: zone,
              })
            }}
            onOk={date => {
              const zone = getTimeZone({
                pzone: timeZone,
                daylightSavings: daylightSaving,
                date,
              })
              setInsertData({
                ...insertData,
                eventend: date.format(saveDateformat),
                eventendTimeZone: zone,
              })
            }}
          />
          <Label>End Time Zone :</Label>
          <Select
            value={insertData.eventendTimeZone}
            onChange={eventendTimeZone =>
              setInsertData({ ...insertData, eventendTimeZone })
            }
          >
            {timeZoneOption({
              pzone: timeZone,
              daylightSavings: daylightSaving,
            }).map(t => (
              <Select.Option key={t.key} value={t.value}>
                {t.text}
              </Select.Option>
            ))}
          </Select>
          <div style={{ gridColumnEnd: 'span 1' }} />
          {/* Wing sir want to diable always */}
          <Label>Event Type :</Label>
          <Select
            value={insertData.eventtype}
            onChange={eventtype => setInsertData({ ...insertData, eventtype })}
          >
            {efffEventType.map(d => (
              <Select.Option key={d.id} value={d.id}>
                {`${d.id} ${d.description ? ' - ' + d.description : ''}`}
              </Select.Option>
            ))}
            {/* <Select.Option key="FO" value="FO">
              FO
            </Select.Option>
            <Select.Option key="IO" value="IO">
              IO
            </Select.Option>
            <Select.Option key="MO" value="MO">
              MO
            </Select.Option>
            <Select.Option key="PO" value="PO">
              PO
            </Select.Option> */}
          </Select>
          {/* <Input
            value={insertData.eventtype}
            disabled
            // onChange={e =>
            //   setInsertData({ ...insertData, eventtype: e.target.value })
            // }
          /> */}

          <Label>Cause Code :</Label>
          <InputNumber
            style={{ width: '100%' }}
            value={insertData.causecode}
            onChange={causecode => setInsertData({ ...insertData, causecode })}
          />
          <Button type="primary" onClick={openCauseCodeDialog}>
            Select Cause Code
          </Button>

          <Label>Contributing Operating Condition :</Label>

          <Select
            value={insertData.contributingCondition}
            onChange={contributingCondition =>
              setInsertData({ ...insertData, contributingCondition })
            }
            style={{ gridColumnEnd: 'span 3' }}
          >
            {contribConditionList.map(d => (
              <Select.Option key={d.contOpCode} value={d.contOpCode}>
                {d.contOpCode}-{d.contOpCondition}
              </Select.Option>
            ))}
          </Select>
          <div />
          <Label>Event Description :</Label>
          <Input.TextArea
            css={{ gridColumnEnd: 'span 4', width: '100%' }}
            value={insertData.description}
            onChange={e =>
              setInsertData({
                ...insertData,
                description: e.target.value,
              })
            }
          />
        </div>
      </Spin>
      {causeCodeDialog.causeCodeDialog && (
        <MultiCauseCode
          key="multicausecodelist"
          // style={{ ...inlineStyle }}
          // checkable={false}
          visibleDialog={causeCodeDialog.causeCodeDialog}
          onDialogClose={onCauseCodeDialogClose}
          onCancelAction={onCauseCodeTreeCancel}
          defaultExpandedKeys={
            insertData.causecode ? causeCodeDialog.selectedKeys : []
          }
          selectedKeys={causeCodeDialog.causeCodeKeyValues}
          selectedValues={causeCodeDialog.causeCodeValues}
          // selectedValues={this.state.causeCodeValues || []}
          unitCodes={[]}
          multiple={false}
          checkable={false}
          selectable
          causeCodeValue={[insertData.causecode]}
          causeCodeList={causeCodeList}
        />
      )}
    </Modal>
  )
}

const mapStateToProps = state => ({
  // eventTypes: getEventTypes(state),
  actionPermits: getPermitActions(state),
})

export default connect(mapStateToProps)(Wind2TurbineEventDialog)
